import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { InstanceRights, RestrictService } from 'src/app/Common/Permissions/restrict.service';
import { IWeissmanModalComponent } from '../../Compliance/WeissmanModalService';
import { ApplicationPermissionService } from '../../Permission/Application/applicationPermission.service';
import { InstancePermissionService } from '../../Permission/Instance/Instance.Permission.Service';
import { UserInstanceService } from '../../User/userInstance.service';
import { UserGroupService } from '../user-group-service.upgrade';

import * as _ from 'lodash';

export interface UserGroupModalParams {
    userGroup: any;
    readOnly: boolean;
    editMode: boolean;
}

@Component({
    selector: 'user-group-modal',
    templateUrl: './userGroupModal.component.html',
    standalone: false
})
export class UserGroupModalComponent implements IWeissmanModalComponent<UserGroupModalParams, any>, OnInit {
    constructor(private readonly _bsModalRef: BsModalRef,
                private readonly _userGroupService: UserGroupService,
                private readonly _toastr: ToastrService,
                private readonly _userInstanceService: UserInstanceService,
                private readonly _instanceRightsService: InstancePermissionService,
                private readonly _applicationPermissionsService: ApplicationPermissionService,
                private readonly _restrictService: RestrictService) {
    }

    params: UserGroupModalParams;
    result: any;

    userGroup;
    companyPermissions = [];
    applicationPermissions = [];
    availableInstanceRights = [];
    permissionsLookup = [];
    editMode: boolean;
    readOnly: boolean;
    saving: boolean;
    hasEditPermission: boolean;
    appPermissionsChanged: boolean;

    siteOptions = ['View All Sites', 'View Some Sites', 'Edit All Sites', 'Hide All Sites'];
    instanceId: number;
    instancePermissions;

    // $scope.$watch('this.ApplicationPermissions', (newVal, oldVal) {
    //     if (!oldVal.length && !newVal.length) {
    //         return;
    //     }
    //
    //     if (!oldVal.length && !firstPass) {
    //         firstPass = true;
    //         return;
    //     }
    //
    //     this.appPermissionsChanged = true;
    // }, true)

    ngOnInit(): void {
        this.editMode = this.params.editMode;
        this.readOnly = this.params.readOnly;

        if (this.params.userGroup) {

            this.userGroup = structuredClone(this.params.userGroup);
            this.instanceId = this.userGroup.instanceId;

            this.companyPermissions = [];

            this._applicationPermissionsService.getByGroupId(this.userGroup.groupID)
                .then((r) => {
                    this.applicationPermissions = r;
                });

            //get assigned instance permissions
            this._instanceRightsService.getByGroupId(this.userGroup.groupID)
                .then((r) => {
                    this.instancePermissions = r;
                });

            //get available instance rights
            this._instanceRightsService.getAllByGroup(this.userGroup.groupID)
                .then((r) => {
                    this.availableInstanceRights = r;
                    this.permissionsLookup = structuredClone(r);
                });
        } else {
            this.userGroup = {
                groupID: 0
            };
            this.instancePermissions = [];
            this._instanceRightsService.getAllByContactId(this._userInstanceService.getInstanceContactId())
                .then((r) => {
                    this.availableInstanceRights = r;
                    this.permissionsLookup = structuredClone(r);
                }
            );
        }

        this.hasEditPermission = this._restrictService.hasInstanceRight(InstanceRights.MANAGEUSERSETUP);
        this.instanceId = this._userInstanceService.getSelectedInstance().instanceId;
    }

    save(): void {
        const userGroupToSave = this.prepareObject();
        this.saving = true;

        this.updateOrCreate(userGroupToSave).catch((error) => {
            this.saving = false;

            this._toastr.error('Error Deleting Group From DB');
            console.warn(error);
        });
    }

    async updateOrCreate(userGroupToSave: any): Promise<void> {
        const batch = true; //force this to be true: previously if one collection was empty then no changes would be saved except the group name and description

        const userGroupObj = {
            deleted: false,
            userGroup: null
        };

        if (userGroupToSave.groupID) {
            await this._userGroupService.update(userGroupToSave, batch);
            userGroupObj.userGroup = this.userGroup;
        } else {
            userGroupToSave.instanceId = this._userInstanceService.getSelectedInstance().instanceId;
            const newGroup = await this._userGroupService.create(userGroupToSave, batch);
            userGroupObj.userGroup = _.omit(newGroup, 'roles', 'permissionDtoList');
        }

        this.result = userGroupObj;
        this._bsModalRef.hide();
    }

    prepareObject(): any {
        const group = structuredClone(this.userGroup);

        group.roles = this.applicationPermissions;

        //console.log('User.Group.Modal.Controller - saving', this.CompanyPermissions);

        group.instancePermissions = this.instancePermissions;

        group.permissionDtoList = this.companyPermissions.filter(x => !!x.efAction);

        return group;
    }

    cancel(): void {
        this._bsModalRef.hide();
    }

    isGroupDirty(): boolean {
        return this.appPermissionsChanged || this.companyPermissions.some(x => x.efAction);
    }

    async deleteUserGroup(): Promise<void> {
        let warningMessage = 'Confirm Deleting User Group.';

        if (this.userGroup.memberCount) {
            warningMessage += ` ${  this.userGroup.memberCount  } users will be removed.`;
        }
        if (confirm(warningMessage)) {
            this.editMode = false;

            try {
                await this._userGroupService.deleteById(this.userGroup.groupID);
                this.result = {
                    deleted: true,
                    userGroup: this.userGroup
                };

                this._bsModalRef.hide();
            } catch (error) {
                this.editMode = true;

                this._toastr.error('Error Deleting Group From DB');
                console.warn(error);
            }
        }
    }

    editUserGroup(): void {
        this.editMode = !!this.hasEditPermission;
    }

    getCancelButtonText(): 'Cancel' | 'Close' {
        return this.editMode ? 'Cancel' : 'Close';
    }
}
